module.exports = __webpack_public_path__ + "static/media/sss-auto-star.8b33575b.svg";